import React from 'react';
import { Box, Divider, Drawer, Toolbar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ScrollableView } from '@uplift/ui-v2';
import { PatientDetailsLayoutProps } from './types';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    flex: 1,
  },
  patientDetails: {
    backgroundColor: theme.palette.common.white,
  },
  patientDetailsDrawerPaper: {
    width: 'calc(100% - 330px)',
  },
  activities: {
    padding: theme.spacing(2),
  },
  assessments: {
    width: '330px',
    borderLeft: `1px solid ${theme.palette.divider}`,
    '& > div:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    }
  }
}));


export function TabletPortraitLayout(props: PatientDetailsLayoutProps) {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <ScrollableView>
        <Box className={classes.patientDetails}>
          <Drawer
            disablePortal
            keepMounted
            style={{ zIndex: 1 }}
            classes={{ paper: classes.patientDetailsDrawerPaper }}
            open={props.patientDetailsExpanded}
            onClose={() => props.setPatientDetailsExpanded?.(false)}
            slotProps={{
              paper: { elevation: 0 }
            }}
          >
            <Toolbar />
            {props.patientDetails}
            <Divider />
            <Box>
              {props.patientAccordions}
            </Box>
          </Drawer>
          {props.patientDetails}
          <Divider />
        </Box>
        <Box className={classes.activities}>
          {props.activities}
        </Box>
      </ScrollableView>
      <Box className={classes.assessments}>
        {props.assessments}
      </Box>
    </Box>
  );
}
